export const aboutData = {
    title: "Why Do I Exist?",
    description1: "To be honest I also have no idea. However from time to time I like to believe the following:",
    description2: "I love to build \"cool\", robust and high quality platforms.\
     I love information and resource sharing, which is why I blog and I am pro-everything-open-source.\
     On the side I am philanthropist, just not rich nor genius nor playboy.",
    image: 1
}